import React, { useMemo } from 'react'
import { IconDown } from '../icon/icon'
import { ErrorReference } from '../error/error-reference'

// Both show the failed request's id with the error (error-reference.js),
// when the error carries one.
export const AlertError = ({ error }) => {
  const lines = useMemo(
    () => {
      if (!error) {
        return []
      }
      if (Array.isArray(error)) {
        return error
      }
      if (typeof error === 'object' && error.message) {
        return [error.message]
      }
      if (typeof error === 'string') {
        return error.split('\n')
      }
      return [String(error)]
    },
    [error]
  )

  return (
    <React.Fragment>
      {lines.length > 0
        ? <div className="alert alert-danger">
            <div className="d-flex">
              <div className="flex-fill">An error occurred</div>
              <a href="#errorCollapse" data-bs-toggle="collapse" role="button">
                <IconDown />
              </a>
            </div>
            <ErrorReference error={error} />
            <div id="errorCollapse" className="collapse">
              <div className="m-2">
                {lines.map((line, i) =>
                  <div key={i}>
                    {line}
                  </div>
                )}
              </div>
            </div>
          </div>
        : <React.Fragment />}
    </React.Fragment>
  )
}

export const AlertErrorMessage = ({ error }) => {
  const last = useMemo(
    () => {
      if (!error) {
        return null
      }

      return error.message || 'An error occurred.'
    },
    [error]
  )

  return (
    <React.Fragment>
      {last &&
        <div className="alert alert-danger">
          <div className="text-capitalize">
            {last}
          </div>
          <ErrorReference error={error} />
        </div>}
    </React.Fragment>
  )
}
